import type { BaseBodyResponse } from "./interfaces";
import { API_BASE_URL } from "../env";
import { PurchaseOrderStatus } from "~/models";

const requestApi = async <T, B = unknown>(
    path: string,
    method: "POST" | "GET" = "GET",
    payload?: B
) => {
    // @TODO: hardcoded temporary
    if (path === "/orders") {
        return {
            ok: true,
            data: {
                orders: [
                    {
                        id: "1",
                        status: PurchaseOrderStatus.Approved,
                        createdAt: "2023-11-01",
                        name: "Coffee",
                        supplier: "Beans in Cup AB",
                        ourReference: "CHSE",
                        deliveryDate: "2023-11-24",
                        companyName: "CHSE",
                        deliveryAddress: "Bondegatan 44. Stockholm, Sweden",
                        postCode: "116 33",
                        estimateText: "Please be quick with the delivery",
                        estimateTextExtended: "Call me when you are here",
                        lines: [
                            {
                                id: "1",
                                name: "Coffee beans",
                                quantity: 4000,
                                unitPrice: 45,
                                costPrice: 180000,
                            },
                            {
                                id: "2",
                                name: "Coffee machine",
                                quantity: 1,
                                unitPrice: 64000,
                                costPrice: 64000,
                            },
                            {
                                id: "3",
                                name: "Coffee cups",
                                quantity: 1000,
                                unitPrice: 3,
                                costPrice: 3000,
                            },
                        ],
                    },
                    {
                        id: "2",
                        status: PurchaseOrderStatus.Pending,
                        createdAt: "2023-11-01",
                        name: "Computers for employees",
                        supplier: "GIGA-BYTE Technology Co., Ltd.",
                        ourReference: "CHSE",
                        deliveryDate: "2024-02-01",
                        companyName: "CHSE",
                        deliveryAddress: "Bondegatan 44. Stockholm, Sweden",
                        postCode: "116 33",
                        estimateText:
                            "Don't send us broken computers as you did last time",
                        estimateTextExtended: "",
                        lines: [
                            {
                                id: "1",
                                name: "Laptops",
                                quantity: 94,
                                unitPrice: 180000,
                                costPrice: 16920000,
                            },
                            {
                                id: "2",
                                name: "Laptop bags",
                                quantity: 94,
                                unitPrice: 1000,
                                costPrice: 94000,
                            },
                            {
                                id: "3",
                                name: "Laptop chargers",
                                quantity: 94,
                                unitPrice: 500,
                                costPrice: 47000,
                            },
                        ],
                    },
                ],
            },
        } as BaseBodyResponse<T>;
    } else if (path === "/me") {
        return {
            ok: true,
            data: {
                isAuth: true,
                email: "supplier-portal@gmail.com",
            },
        } as BaseBodyResponse<T>;
    }

    const url = `${API_BASE_URL}${path}`;
    const body = payload ? JSON.stringify(payload) : undefined;
    const response = await fetch(url, {
        method,
        body,
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    const json = await response.json();

    // @TODO: clean up
    // if (!response.ok) {
    //     throw new Error(json.error);
    // }

    return json as BaseBodyResponse<T>;
};

export default requestApi;
